import { motion } from "framer-motion";
import { useTheme } from "@/hooks/use-theme";
import { useEffect, useRef } from "react";
import { LandingAtmosphere } from "@/components/landing/LandingAtmosphere";
import { LandingFooter } from "@/components/landing/LandingFooter";

export default function QuemSomosPage() {
  // Page is always light — restore previous theme on unmount
  const { theme, setTheme } = useTheme();
  const originalTheme = useRef(theme);
  useEffect(() => {
    if (theme !== "light") {
      setTheme("light");
    }
  }, [theme, setTheme]);
  useEffect(() => {
    return () => setTheme(originalTheme.current);
  }, [setTheme]);

  return (
    <div className="relative isolate min-h-screen overflow-x-hidden bg-transparent text-foreground">
      <LandingAtmosphere />

      {/* Content */}
      <main className="mx-auto max-w-3xl px-6 pt-16 pb-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            Quem somos
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Conheça a UrbNet e nossa missão
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-12 space-y-6 leading-relaxed text-muted-foreground"
        >
          <p>
            A Marelli Desenvolvimentos Eireli, localizada em Cachoeiro de Itapemirim, Espírito Santo, surgiu de uma constatação simples: as cidades brasileiras lidam, há anos, com os mesmos problemas urbanos — não por falta de boa vontade da gestão pública, mas por não disporem de uma infraestrutura digital que transforme uma reclamação em uma ação rastreável.
          </p>
          <p>
            O UrbNet preenche essa lacuna. Somos uma plataforma gov-tech que integra cidadãos, ouvidorias municipais e gestores públicos em um único ecossistema — contando com Inteligência Artificial para validação em tempo real de evidências, hierarquia institucional confirmada, SLA público e total auditabilidade para os órgãos de controle.
          </p>
          <p>
            Não somos uma versão de um produto importado, tampouco uma imitação do que já está disponível no mercado brasileiro. O UrbNet foi idealizado desde o início, levando em consideração a realidade prática das prefeituras — tanto de cidades com 20 mil habitantes quanto das capitais — e a exigência crescente de transparência que os Tribunais de Contas estaduais estão impondo.
          </p>
          <p>
            Temos a convicção de que a tecnologia urbana não pode ser exclusiva de grandes cidades com orçamentos consideráveis. É por isso que desenvolvemos uma plataforma escalável, com planos que são adequados ao tamanho de cada município, e uma arquitetura de dados que garante a proteção do cidadão — que utiliza o aplicativo de forma anônima — enquanto fornece ao gestor público a inteligência necessária para tomar decisões.
          </p>
          <p>
            O UrbNet é, antes de tudo, uma crença de que a gestão urbana eficiente e a transparência pública não são objetivos inalcançáveis — são simplesmente o próximo passo lógico para qualquer prefeitura que deseja se antecipar ao seu tempo.
          </p>
        </motion.div>
      </main>

      <LandingFooter />
    </div>
  );
}
